/* Frisco Wash: cart upsell "Add" buttons (drawer and cart page) */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-fw-add]');
  if (!b) return;
  e.preventDefault();
  b.setAttribute('aria-busy', 'true'); b.disabled = true;
  var onCart = /^\/cart\/?$/.test(location.pathname);
  var body = { id: Number(b.getAttribute('data-fw-add')), quantity: 1 };
  if (!onCart) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
  fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
  }).then(function (r) { return r.json(); }).then(function (s) {
    var d = document.querySelector('cart-drawer');
    if (!onCart && d && s.sections && typeof d.renderContents === 'function') { d.renderContents(s); }
    else { location.reload(); }
  }).catch(function () { location.href = '/cart'; });
});
